export default {
    buttons: {
        lecture: 'With Teacher',
        self: 'Self-directed',
    },
    moduleLabel: {
        cardWriting: 'Card Writing 💬️',
        wordCheck: 'Word Check',
        wordWriting: 'Word Writing',
        wordSelection: 'Word Selection',
        seedLetter: 'Seed Letter',
        oxQuiz: 'OX Quiz',
        fillInTheBlanks: 'Fill in the Blanks',
        proConDebate: 'Debate',
        segmentedReading: 'Guided Reading',
        sentenceOrdering: 'Sentence Ordering',
        correctTheMistakes: 'Correct the Mistakes',
        postIt: 'Complete the Table',
        magicWordTest: "I Know! Don't Know?",
        talkQuiz: 'Talk Quiz',
    },
};
